export default __webpack_public_path__ + "static/snapdeal-thumbnail-4782a27bcd688b3036c92fae93a2eedb.png";